import React, { Fragment, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DialogSelector from "../register_login/DialogSelector";
import AOS from "aos";
import "aos/dist/aos.css";
const styles = (theme) => ({
  body: {
    backgroundColor: "red !important",
  },
  container: {
    zIndex: 1,
    width: "100%",
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "5em 2em",
    position: "relative",

    [theme.breakpoints.up("lg")]: {
      maxWidth: "1350px",
    },

    [theme.breakpoints.down("md")]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },

  backedBy: {
    textAlign: 'center', // Centers the text
    width: '100%', // Ensures the div takes the full width
    fontSize: '1rem', // Adjust the font size as needed
    marginTop: theme.spacing(2), // Space from the top
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem', // Smaller font size for mobile screens
    },
  },

  techstarsLogo: {
    display: 'block', // Use block to center the image with margin auto
    marginLeft: 'auto', // Center the image
    marginRight: 'auto', // Center the image
    width: 'auto', // Keeps aspect ratio
    height: '50px', // Adjust the height as needed
    [theme.breakpoints.down('sm')]: {
      height: '30px', // Smaller height for mobile screens
    },
  },

  mainHeading: {
    width: "100%",
    textAlign: "center",
    letterSpacing: "-3.6px",
    fontSize: "96px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    lineHeight: 1.1,
    display: "block",

    [theme.breakpoints.down("md")]: {
      letterSpacing: "-2px",
      fontSize: "80px",
    },
    [theme.breakpoints.down("sm")]: {
      letterSpacing: "-1px",
      fontSize: "34px",
    },
  },
  headingText: {
    width: "100%",
    maxWidth: "800px",
    color: "#606060",
    marginBottom: "20px",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    fontSize: "20px",
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
  },
  gradientText: {
    backgroundImage: "linear-gradient(to right, #6557ff, #aa3fff 80%)",
    textAlign: "center",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
  },
  gradientBG: {
    zIndex: -1,
    width: "100%",
    position: "absolute",
    top: 0,
    bottom: "-40%",
    left: 0,
    right: 0,
    overflow: "hidden",

    "& div": {
      zIndex: -1,
      width: "100%",
      backgroundImage:
        "linear-gradient(130deg, #6557ff, #aa3fff 30%, #aa3fff 63%, #fcaa4a 81%)",
      opacity: 0.15,
      filter: "blur(150px)",
      position: "absolute",
      top: 0,
      bottom: "40%",
      left: 0,
      right: 0,
    },
  },
  callToAction: {
    backgroundImage: "url('/images/logged_out/Arrow-Icon.svg')",
    backgroundPosition: "86%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "14px",
    marginLeft: "300px",
    marginRight: "300px",
    transition: "background-position .5s, background-color .3s, color .35s",
    height: "48px",
    color: "#fff",
    textDecoration: "none",
    textTransform: "uppercase",
    backgroundColor: "#000",
    borderRadius: "12px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 30px",
    fontSize: "18px",
    transition: "background .3s, color .35s",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    color: "white",
    fontWeight: 500,
    backgroundColor: "rgba(0, 0, 0, 0)",
    "&:hover": {
      backgroundPosition: "90%",

      "& .button-gradient-bg": {
        right: 0,
      }
    },

    "@media screen and (max-width: 991px)": {
      marginLeft: "140px",
      marginRight: "140px",
    },
    "@media screen and (max-width: 767px)": {
      marginLeft: "80px",
      marginRight: "80px",
      backgroundPosition: "90%",
      fontSize: "14px",

      "&:hover": {
        backgroundPosition: "98%",


      },
    },
    "@media screen and (max-width: 479px)": {
      marginLeft: "20px",
      marginRight: "30px",
    },

    "& .button-gradient-bg": {
      zIndex: -1,
      backgroundImage:
        "linear-gradient(to right, #6557ff, #6557ff 46%, #f8522e)",
      opacity: 1,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: "-220px",
      transition: "all 200ms"


    },
  },
});

function HeadSection(props) {
  const { classes, theme } = props;
  const isWidthUpLg = useMediaQuery(theme.breakpoints.up("lg"));

  const [dialogOpen, setDialogOpen] = useState(null);

  const [open, setOpen] = useState(false);

  const closeDialog = useCallback(() => {
    setDialogOpen(null);
  }, [setDialogOpen]);

  const openRegisterDialog = useCallback(() => {
    setDialogOpen("register");
  }, [setDialogOpen]);

  const closeModal = () => {
    setOpen(false);
  };

  const openModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Fragment>
      <div className={classes.container}>
        <Typography
          className={classes.mainHeading}
          variant="h1"
          fontWeight={500}
          textAlign="center"
          data-aos="fade-up"
          data-aos-easing="ease-out"
        >
          We hope you enjoyed the&nbsp;

          <span className={classes.gradientText}>pitch!</span>
        </Typography>
        <p
          data-aos="fade-up"
          data-aos-easing="ease-out"
          data-aos-delay="300"
          className={classes.headingText}
        >
          Join us at Auralyze.ai as we pave the way for groundbreaking advancements. Interested in learning more? Let's connect!
        </p>
        <a href="https://calendly.com/auralyzeai/investor-meeting" className={classes.callToAction}>
          <div className="text-block">Connect Over a Virtual Coffee ☕️!</div>
          <div className="button-gradient-bg"></div>
        </a>
      </div>
      <div className={classes.gradientBG}>
        <div></div>
      </div>
      <DialogSelector
        dialogOpen={dialogOpen}
        onClose={closeDialog}
        openRegister
        Dialog={openRegisterDialog}
      />

      <Typography
        className={classes.backedBy}
        data-aos="fade-up"
        data-aos-delay="400"
      >
        Backed by
      </Typography>

      {/* Techstars logo */}
      <img
        src="https://cdn.bfldr.com/T71J6AJ4/at/q6kn4m-tw6a8-58o1a5/Techstars_Logo_Primary_Black.eps?auto=webp&format=eps" // Replace with the path to your logo
        alt="Techstars Logo"
        className={classes.techstarsLogo}
        data-aos="fade-up"
        data-aos-delay="450" // Adjust the delay as needed
      />
    </Fragment>
  );
}

HeadSection.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(HeadSection);
